import { useCartV2 } from 'contexts';
import { ComboItem } from 'types';
import { ComboDetailPayload } from '@teko/discovery';
import { AddItemsProduct } from '@teko/cart/v2';

export const useCartCombo = (mainSku: string) => {
  const { onAddMultipleItems, onAddComboItems } = useCartV2();

  const onAddComboToCart = !mainSku
    ? null
    : async (
        type: ComboItem['type'],
        payload: ComboDetailPayload,
        override = true,
      ) => {
        if (type === 'autogen') {
          const body: AddItemsProduct[] = payload.comboLineItems.map(
            (item) => ({ ...item, promotionId: item.selectPromotionId }),
          );
          await onAddMultipleItems(body);
        } else {
          const mainPayload = {
            override,
            groups: [
              {
                quantity: 1,
                promotionId: payload.promotionId,
                products: payload.comboLineItems.map((el, index) => ({
                  sku: el.sku,
                  quantity: el.quantity,
                  isPrimary: index === 0,
                })),
              },
            ],
          };
          await onAddComboItems(mainPayload, false);
        }
      };
  return {
    onAddComboToCart,
  };
};
